"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsDtoBuilder = exports.StaffDtoBuilder = void 0;
var StaffDtoBuilder = /** @class */ (function () {
    function StaffDtoBuilder() {
        this.staff = {
            resource: {
                id: "staff-id-".concat(Math.random()),
                name: 'some-name',
                phone: "staff-phone-".concat(Math.random()),
                email: 'some-email',
                description: 'some-description',
                images: [
                    {
                        url: 'some-url',
                    },
                ],
            },
            slugs: [
                {
                    name: 'some-slug-name',
                },
            ],
        };
    }
    StaffDtoBuilder.prototype.withName = function (name) {
        this.staff.resource.name = name;
        return this;
    };
    StaffDtoBuilder.prototype.withDescription = function (description) {
        this.staff.resource.description = description;
        return this;
    };
    StaffDtoBuilder.prototype.withPhone = function (phone) {
        this.staff.resource.phone = phone;
        return this;
    };
    StaffDtoBuilder.prototype.withEmail = function (email) {
        this.staff.resource.email = email;
        return this;
    };
    StaffDtoBuilder.prototype.withImage = function (image) {
        this.staff.resource.images = [image];
        return this;
    };
    StaffDtoBuilder.prototype.withSlug = function (slug) {
        this.staff.slugs = [slug];
        return this;
    };
    StaffDtoBuilder.prototype.build = function () {
        return this.staff;
    };
    return StaffDtoBuilder;
}());
exports.StaffDtoBuilder = StaffDtoBuilder;
var SettingsDtoBuilder = /** @class */ (function () {
    function SettingsDtoBuilder() {
    }
    return SettingsDtoBuilder;
}());
exports.SettingsDtoBuilder = SettingsDtoBuilder;
//# sourceMappingURL=catalog-staff.dto.builder.js.map